import PersonalAreaView from './personal-area-view';

export default PersonalAreaView;
